import ReactGA from "react-ga4";
import { history } from "./router.js";

// Initialize ReactGA with more configuration options
ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID, {
  testMode: process.env.NODE_ENV === "development",
  debug: process.env.NODE_ENV === "development",
  gaOptions: {
    siteSpeedSampleRate: 100,
  },
});

// Enhanced Analytics Service
class Analytics {
  static pageView(path) {
    ReactGA.send({
      hitType: "pageview",
      page: path,
    });
  }

  // User Events
  static trackUserSignup(method) {
    ReactGA.event({
      category: "User",
      action: "Signup",
      label: method,
    });
  }

  static trackUserLogin(method) {
    ReactGA.event({
      category: "User",
      action: "Login",
      label: method,
    });
  }

  // Document Generation Events
  static trackDocumentGeneration(type, success) {
    ReactGA.event({
      category: "Generation",
      action: type,
      label: success ? "Success" : "Failed",
      nonInteraction: false,
    });
  }

  static trackGenerationTime(type, timeMs) {
    ReactGA.event({
      category: "Performance",
      action: "Generation Time",
      label: type,
      value: Math.round(timeMs),
    });
  }

  // Form Events
  static trackFormStep(formName, step) {
    ReactGA.event({
      category: "Form",
      action: "Step Complete",
      label: `${formName} - Step ${step}`,
    });
  }

  static trackFormSubmission(formName) {
    ReactGA.event({
      category: "Form",
      action: "Submit",
      label: formName,
    });
  }

  // Error Events
  static trackError(error, componentName) {
    ReactGA.event({
      category: "Error",
      action: error.name || "Unknown",
      label: `${componentName}: ${error.message}`,
      nonInteraction: true,
    });
  }

  // E-commerce Events
  static trackPurchase(transaction) {
    ReactGA.event({
      category: "Ecommerce",
      action: "Purchase",
      label: transaction.plan,
      value: transaction.value,
    });
  }

  static trackSubscriptionStart(plan) {
    ReactGA.event({
      category: "Subscription",
      action: "Start",
      label: plan,
    });
  }

  // Feature Usage Events
  static trackFeatureUsage(feature) {
    ReactGA.event({
      category: "Feature",
      action: "Use",
      label: feature,
    });
  }

  // Document Events
  static trackDocumentView(docType) {
    ReactGA.event({
      category: "Document",
      action: "View",
      label: docType,
    });
  }

  static trackDocumentDownload(docType) {
    ReactGA.event({
      category: "Document",
      action: "Download",
      label: docType,
    });
  }

  // User Properties
  static setUserProperties(properties) {
    ReactGA.set(properties);
  }
}

// Track initial pageview
if (typeof window !== "undefined") {
  Analytics.pageView(window.location.pathname + window.location.search);
}

// Track pageview on route change
history.listen((location) => {
  Analytics.pageView(location.pathname + location.search);
});

export default Analytics;
